export default "__VITE_ASSET__CtTT$LmX__"